/**
 * Chat 1:1 con polling.
 */
import { api } from "./client";
import type { MatchUser } from "./matches";

export interface ChatThread {
  peer: MatchUser;
  last_message_body: string | null;
  last_message_at: string;
  last_from_me: boolean;
  unread_count: number;
}

export interface ChatMessage {
  id: number;
  from_user_id: number;
  to_user_id: number;
  body: string | null;
  kind: string;
  related_proposal_id: number | null;
  created_at: string;
  read_at: string | null;
}

export async function fetchThreads(): Promise<ChatThread[]> {
  return api<ChatThread[]>("/messages/threads");
}

export async function fetchConversation(withUserId: number, limit = 100): Promise<ChatMessage[]> {
  return api<ChatMessage[]>(`/messages?with_user_id=${withUserId}&limit=${limit}`);
}

export async function sendMessage(toUserId: number, body: string, kind = "text"): Promise<ChatMessage> {
  return api<ChatMessage>("/messages", {
    method: "POST",
    body: JSON.stringify({ to_user_id: toUserId, body, kind }),
  });
}
